import { SAVE_NATIONALITY, FETCH_NATIONALITY, FETCH_NATIONALITY_FAIL } from './types';
import axios from 'axios';
import { SLACK_WEBHOOKS } from '../config';
import { SlackWebhook } from './utils';

/**
 * Save nationality payload from Busabout Matrix page
 */
export function SaveNationality(data){
  return dispatch => dispatch({type:SAVE_NATIONALITY, payload:data})
}


/**
 * Fetch nationality via Busabout API
 */
export function FetchNationality(){

  const nationlityURL = `${process.env.REACT_APP_NATIONALITY_API}?api_token=${process.env.REACT_APP_API_TOKEN}`;

  return async dispatch => {
    try{
      const data = await axios.get(nationlityURL, {withCredentials: true});
      dispatch({type:FETCH_NATIONALITY, payload:data});
    }
    catch(err){
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':`Botch! NATIONALITY API - ` + nationlityURL + err}));
      dispatch({type:FETCH_NATIONALITY_FAIL});
      console.log(err);
    };
  }
}



// WEBPACK FOOTER //
// ./src/actions/nationality.js